import {useSelector} from "react-redux";
import {selectUserFields} from "../store/slices/user.slice";

const useAccountInfo = ()=>{
    const settings = useSelector((state) =>
        selectUserFields(state, "settings")
    );
    const company = useSelector((state) =>
        selectUserFields(state, "company_details")
    );
    const username = settings?.display_name

    return {
        settings,
        company,
        username
    }
}

export default useAccountInfo;